import { detectLocale } from "./detectLocale";
import { messagesByLocale } from "./locales";
import { createTranslator } from "./translate";

export function getTranslator(locale = detectLocale()) {
    return createTranslator(messagesByLocale[locale] || messagesByLocale.en);
}
